var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-10C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0ZM3.68 5.384l6 5 .322.269.32-.271 4.09-3.46-.645-.764-3.77 3.19L4.32 4.615l-.64.768Z",
    fill: "inherit"
  })));
};
export default SvgStopwatch;